import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';

import './styles/CardHeader.css';

export default function CardHeader({
  image,
  profileType,
  username,
  subtitle = null,
  timeAgo,
  onUserClick = null,
  className = '',
}) {
  const handleClick = (e) => {
    if (!onUserClick) return;
    e.stopPropagation();
    onUserClick(e);
  };

  return (
    <div className={["card-header", className].filter(Boolean).join(" ")}> 
      <UserProfileImage
        image={image}
        typeOfProfile={profileType}
        className="card-header__avatar"
        onClick={handleClick}
      />
      <div className="card-header__texts">
        <Text className="card-header__username" onClick={handleClick}>
          {username}
        </Text>
        {subtitle && (
          <Text className="card-header__subtitle">
            {subtitle}
          </Text>
        )}
      </div>
      <Text className="card-header__time">
        {timeAgo}
      </Text>
    </div>
  );
}